module.exports = __webpack_public_path__ + "img/set.8a9eb993.svg";